import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/economic-order-quantity',
  component: () => import('../../routes/EconomicOrderQuantity.svelte'),
  card: {
    id: 'economic-order-quantity',
    title: 'EOQ Calculator',
    description: 'Find the optimal order quantity to minimize total inventory costs.',
    icon: 'inventory_2',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/economic-order-quantity',
    category: 'Business',
  },
  seo: {
    title: 'EOQ Calculator - Economic Order Quantity',
    description: 'Calculate the optimal order quantity to minimize total inventory costs. Uses the Wilson EOQ formula to find the balance between ordering and holding costs.',
  },
};

export default meta;